module.exports = __webpack_public_path__ + "static/media/home.dd6addcb.svg";